import AuthGuard from '@/guard/auth'
import Navbar from '@/components/menu/Navbar'
import IamGuard from '@/guard/iam'
import DuplicateTasksPage from '@/components/pages/DuplicateTasksPage'
import { DuplicateContextProvider } from '@/context/duplicate'

function Duplicate() {
	return (
		<AuthGuard>
			<IamGuard page='duplicate'>
				<DuplicateContextProvider>
					<div className='relative min-h-screen flex flex-col'>
						<Navbar></Navbar>
						<DuplicateTasksPage></DuplicateTasksPage>
					</div>
				</DuplicateContextProvider>
			</IamGuard>
		</AuthGuard>
	)
}

export default Duplicate
